import { render } from "./MWEventDates.vue?vue&type=template&id=ffd2cb68"
import script from "./MWEventDates.vue?vue&type=script&lang=js"
export * from "./MWEventDates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__